import * as React from "react";
import Box from "@mui/material/Box";
import { DataGrid, GridColDef, GridSortModel } from "@mui/x-data-grid";
import { useCallback, useEffect, useState } from "react";
import HttpService from "../../../../Hooks/Https-services";
import { APIRoutes, PageRoutes } from "../../../../Utils/constant";
import { useNavigate } from "react-router-dom";
import { Button, TextField } from "@mui/material";
import ActionButtons from "./ActionButtons";

const columns: GridColDef[] = [
  { field: "bumper_url", headerName: "Bumper Url", width: 700 },
  {
    field: "duration",

    headerName: "Duration",

    sortable: true,
  },

  {
    field: "action",
    headerName: "Action",
    sortable: false,
    renderCell: (data: any) => {
      return (
        <>
          <ActionButtons data={data} />
        </>
      );
    },
    filterable: false,
    hideable: false,
    editable: false,
    width: 300,
  },
];

export default function VideoListTable({
  bumpers,
  totalPage,
  handleSortModelChange,
  paginationModel,
  setPaginationModel,
}: {
  bumpers: any;
  totalPage: number;
  handleSortModelChange: any;
  paginationModel: any;
  setPaginationModel: any;
}) {
  const navigate = useNavigate();
  return (
    <Box sx={{ maxHeight: "100vh", width: "100%" }}>
      <DataGrid
        rows={bumpers}
        pagination
        rowCount={totalPage}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        sortingMode="server"
        onSortModelChange={handleSortModelChange} // Handle sort change
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        disableColumnSelector
        disableDensitySelector
        disableColumnFilter
        disableColumnMenu
        disableColumnResize
        disableColumnSorting
        disableRowSelectionOnClick
        sx={{
          borderRadius: "8px",
          "& .MuiDataGrid-row:hover": {
            cursor: "pointer",
          },
          ".MuiDataGrid-cellContent": {
            pointerEvents: "none",
          },
          ".MuiDataGrid-cell--textLeft": {
            alignItems: "center !important",
            display: "flex",
          },
        }}
        paginationMode="server" // Enable server-side pagination
      />
    </Box>
  );
}
